
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/kamerki",
      function () {
        return require("private-next-pages/[region]/[resort]/kamerki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/kamerki"])
      });
    }
  